import { render } from "./UploadPage.vue?vue&type=template&id=220a6011&scoped=true"
import script from "./UploadPage.vue?vue&type=script&lang=js"
export * from "./UploadPage.vue?vue&type=script&lang=js"

import "./UploadPage.vue?vue&type=style&index=0&id=220a6011&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220a6011"]])

export default __exports__